import logo from './logo.svg';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import DashboardView from './pages/DashboardView';
import AppsToDoList from './pages/AppsToDoList';
import AppsNotes from './pages/AppsNotes';
import AppsScrumboard from './pages/AppsScrumboard';
import AppsDTCustom from './pages/AppsDTCustom';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import LockScreen from './pages/LockScreen';
import PrivateRoute from './pages/PrivateRoute';
import { AuthProvider } from './pages/contexts/AuthContext';
import Logout from './pages/Logout';
import TimeoutWarning from './pages/TimeOutWarning';
import Notes from './pages/Notes';

// import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/bootstrap/css/bootstrap.min.css';




function App() {
  return (
    <BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Login/>}></Route>
        <Route path="/login" element={<Login/>}></Route>
        <Route path="/lockscreen" element={<LockScreen/>}></Route>
        <Route path="/timeoutwarning" element={<TimeoutWarning/>}></Route>
        <Route path="/admin/login" element={<AdminLogin/>}></Route>
        <Route path="/dashboard" element={<PrivateRoute><DashboardView/></PrivateRoute>}></Route>
        <Route path="/appstodolist" element={<PrivateRoute><AppsToDoList/></PrivateRoute>}></Route>
        <Route path="/appsnotes" element={<PrivateRoute><Notes/></PrivateRoute>}></Route>
        <Route path="/appsscrumboard" element={<PrivateRoute><AppsScrumboard/></PrivateRoute>}></Route>
        <Route path="/appsdtcustom" element={<PrivateRoute><AppsDTCustom/></PrivateRoute>}></Route>

        <Route path="/logout" element={<Logout/>} />

      </Routes>
    </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
